export const DEFAULT_MOBILE_DURATION = 5000;
export const DEFAULT_DESKTOP_DURATION = 6000;
